/**
 * Utility for caching critical DOM elements to avoid expensive lookups during render/interaction.
 */

const elements = new Map<string, HTMLElement | SVGElement>();

export function getEl<T extends HTMLElement | SVGElement>(id: string): T {
    let el = elements.get(id) as T;
    if (!el || !document.body.contains(el)) {
        el = document.getElementById(id) as T;
        if (el) elements.set(id, el);
        else elements.delete(id);
    }
    return el;
}

const socketCache = new Map<string, HTMLElement>();

export function getSocketEl(nodeId: string, portIdx: number, io: 'in' | 'out'): HTMLElement | null {
    const key = `${nodeId}-${portIdx}-${io}`;
    let el: HTMLElement | null | undefined = socketCache.get(key);
    if (!el || !document.body.contains(el)) {
        el = document.querySelector(`[data-node="${nodeId}"][data-port="${portIdx}"][data-io="${io}"]`) as HTMLElement | null;
        if (el) socketCache.set(key, el);
        else socketCache.delete(key);
    }
    return el || null;
}

export function clearDOMCache(): void {
    elements.clear();
    socketCache.clear();
}
